import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import {asPrimaryButton, asSecondaryButton, asSecondaryButtonInverted, asTertiaryButton, asBorderlessButton} from '../button/index'
// import * as mixpanel from '../../../util/mixpanel';
import './unilink.css'

function _track(event) {
  //mixpanel.track(`XP_${event}`)
}

export const UniLink = ({onClick, to, href, type, track, underline, navLink, activeStyle, activeClassName, style={}, ...others}) => {
  let clickFunctionProps = {
    'onClick': () => {
      if (track) {
        _track(track)
      }
    }
  }
  style['textDecoration'] =  underline ? 'initial' : 'none'
  if (onClick) {
    const clickFunction = (e) => {
      e.preventDefault()
      clickFunctionProps.onClick()
      onClick()
    }
    return (
      <a style={style} href={href ? href : '#'} onClick={clickFunction} {...others} />
    )
  } else if (to) {
    if (navLink && (activeStyle || activeClassName)) {
      return (
        <NavLink style={style} activeStyle={activeStyle} activeClassName={activeClassName} to={to} {...others} {...clickFunctionProps} />
      )
    } else {
      return (
        <Link style={style} to={to} {...others} {...clickFunctionProps} />
      )
    }
  } else if (type && type==='submit') {
    return (
      <button type={type} {...others} {...clickFunctionProps} />
    )
  } else {
    return (
      <a style={style} href={href} {...others} {...clickFunctionProps} />
    )
  }
}

export const PrimaryButton = asPrimaryButton(UniLink)
export const SecondaryButton = asSecondaryButton(UniLink)
export const SecondaryButtonInverted = asSecondaryButtonInverted(UniLink)
export const TertiaryButtonLight = asTertiaryButton(UniLink, true)
export const TertiaryButtonDark = asTertiaryButton(UniLink, false)
export const BorderlessButtonLight = asBorderlessButton(UniLink, true)
export const BorderlessButtonDark = asBorderlessButton(UniLink, false)



// WEBPACK FOOTER //
// ./src/core/components/unilink/index.js